/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { RuleScript } from './RuleScript.js';
import {
    RuleScriptFromJSON,
    RuleScriptFromJSONTyped,
    RuleScriptToJSON,
} from './RuleScript.js';
import type { RuleType } from './RuleType.js';
import {
    RuleTypeFromJSON,
    RuleTypeFromJSONTyped,
    RuleTypeToJSON,
} from './RuleType.js';

/**
 * 
 * @export
 * @interface Rule
 */
export interface Rule {
    /**
     * 
     * @type {number}
     * @memberof Rule
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Rule
     */
    order?: number;
    /**
     * 
     * @type {number}
     * @memberof Rule
     */
    maxScore?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Rule
     */
    isManual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Rule
     */
    isGlobal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Rule
     */
    isScriptAdherence?: boolean;
    /**
     * 
     * @type {RuleType}
     * @memberof Rule
     */
    type?: RuleType;
    /**
     * 
     * @type {Date}
     * @memberof Rule
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Rule
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Rule
     */
    isDraft?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Rule
     */
    sectionId?: number;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    sectionName?: string;
    /**
     * 
     * @type {RuleScript}
     * @memberof Rule
     */
    script?: RuleScript;
}

/**
 * Check if a given object implements the Rule interface.
 */
export function instanceOfRule(value: object): boolean {
    return true;
}

export function RuleFromJSON(json: any): Rule {
    return RuleFromJSONTyped(json, false);
}

export function RuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Rule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'maxScore': json['maxScore'] == null ? undefined : json['maxScore'],
        'isManual': json['isManual'] == null ? undefined : json['isManual'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
        'isScriptAdherence': json['isScriptAdherence'] == null ? undefined : json['isScriptAdherence'],
        'type': json['type'] == null ? undefined : RuleTypeFromJSON(json['type']),
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
        'sectionId': json['sectionId'] == null ? undefined : json['sectionId'],
        'sectionName': json['sectionName'] == null ? undefined : json['sectionName'],
        'script': json['script'] == null ? undefined : RuleScriptFromJSON(json['script']),
    };
}

export function RuleToJSON(value?: Rule | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'order': value['order'],
        'maxScore': value['maxScore'],
        'isManual': value['isManual'],
        'isGlobal': value['isGlobal'],
        'isScriptAdherence': value['isScriptAdherence'],
        'type': RuleTypeToJSON(value['type']),
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'isDraft': value['isDraft'],
        'sectionId': value['sectionId'],
        'sectionName': value['sectionName'],
        'script': RuleScriptToJSON(value['script']),
    };
}

